import React from 'react';
import styled from 'styled-components';

export default function Text(props) {
  const Text = styled.div`
    color: ${props.color};
    font-weight: ${props.fontWeight};
    font-variant: ${props.fontVariant};
    font-size: ${props.fontSize};
    text-align: ${props.textAlign};
    margin: ${props.margin};
  `;

  return <Text>{props.children}</Text>;
}
